<script>
  /**@type {string?} */
  export let label = null
  export let value = ''
  export let id = `textarea-${Math.random().toString(32).substring(2)}`

  /**@type {number} */
  export let rows = 4

  $: hasLabel = $$slots.label || label
</script>

<label class="textarea" for={id}>
  {#if hasLabel}
    <span class="label">
      <slot name="label">{label}</slot>
    </span>
  {/if}
  <textarea
    bind:value
    {id}
    {...$$restProps}
    class="field {$$restProps.class || ''}"
    {rows}></textarea>
</label>

<style>
  .label + .field {
    margin-top: 0.5rem;
  }

  .textarea {
    flex: 0 0 auto;
    display: block;
    width: 100%;
    position: relative;
  }

  .field {
    display: block;
    flex: 1 1 auto;
    width: 100%;
    padding: 0.7rem 1rem;
    border: 1px solid rgba(var(--rgb-gray), 0.25);
    border-radius: var(--border-radius-sm);
    background: var(--background);
    color: rgb(var(--rgb-text));
    font-size: 1rem;
    text-overflow: ellipsis;
    appearance: none;
    box-shadow: var(--box-shadow-sm);
    transition: var(--box-shadow-transition);
    resize: none;
  }

  .field--textarea {
    height: auto;
    padding: 0.8rem 1rem;
    line-height: 1.4;
  }

  .label {
    display: inline-block;
    flex: 1 1 0;
    font-weight: 550;
    line-height: 1.2;
    font-size: 1rem;
    text-wrap: balance;
  }

  textarea {
    overflow: auto;
  }
</style>
